export function isNullish(val) {
    return val === null || val === undefined;
}
// someArray.filter(isNotNullish)
export function isNotNullish(p) {
    return !isNullish(p);
}
// objectFilter(obj).filter(isNotNullish_keyVal)
export function isNotNullish_keyVal(arg) {
    return !isNullish(arg[1]);
}
